export default __webpack_public_path__ + "static/ClarityNuvo-Bold-cf5019043134ff4d445b23749407483f.woff";